import { useState, useEffect } from "react";

function Win(props) {
  const [winnerMessage, setWinnerMessage] = useState();
  const [winTime, setWinTime] = useState();

  useEffect(() => {
    checkTie();
    pushWinTime();
  }, [props.memory]);

  function pushWinTime() {
    setWinTime(props.time);
  }

  function checkWinner() {
    if (props.points1 > props.points2 || props.points3 || props.points4) {
      setWinnerMessage("Player 1 Wins!");
    } else if (
      props.points2 > props.points1 ||
      props.points3 ||
      props.points4
    ) {
      setWinnerMessage("Player 2 Wins!");
    } else if (
      props.points3 > props.points2 ||
      props.points1 ||
      props.points4
    ) {
      setWinnerMessage("Player 3 Wins!");
    } else if (
      props.points4 > props.points2 ||
      props.points3 ||
      props.points1
    ) {
      setWinnerMessage("Player 4 Wins!");
    }
  }

  function checkTie() {
    if (props.points1 === props.points2 || props.points3 || props.points4) {
      setWinnerMessage("It's a tie!");
    } else if (
      props.points2 === props.points1 ||
      props.points3 ||
      props.points4
    ) {
      setWinnerMessage("It's a tie2!");
    } else if (
      props.points3 === props.points2 ||
      props.points1 ||
      props.points4
    ) {
      setWinnerMessage("It's a tie3!");
    } else if (
      props.points4 === props.points2 ||
      props.points3 ||
      props.points1
    ) {
      setWinnerMessage("It's a tie4!");
    } else {
      checkWinner();
    }
  }

  return (
    <div
      className={
        (props.grid === "4x4" && props.winningPair.length === 16) ||
        (props.grid === "6x6" && props.winningPair.length === 36)
          ? "win"
          : "off"
      }
    >
      <div className={props.players.length > 1 ? "off" : "win-card"}>
        <h2>You did it!</h2>
        <p>Game over! Here are the results...</p>
        <div className="win-subcard">
          <h3>Time Elapsed</h3>
          <p>
            {Math.floor(winTime / 60)}:
            {parseInt(winTime % 60) < 10
              ? "0" + parseInt(winTime % 60)
              : parseInt(winTime % 60)}
          </p>
        </div>
        <div className="win-subcard">
          <h3>Moves Taken</h3>
          <p>{props.moves} Moves</p>
        </div>
        <button
          className="win-card-button win-card-button-1"
          onClick={props.restart}
        >
          Restart
        </button>
        <button className="win-card-button" onClick={props.newGame}>
          New Game
        </button>
      </div>

      <div className={props.players.length > 1 ? "win-card" : "off"}>
        <h2>{winnerMessage}</h2>
        <p>Game over! Here are the results...</p>
        <div
          className={props.players.length > 1 ? "win-sub-card-multi" : "off"}
        >
          <h3>Player 1</h3>
          <p>{props.points1}</p>
        </div>
        <div
          className={props.players.length > 1 ? "win-sub-card-multi" : "off"}
        >
          <h3>Player 2</h3>
          <p>{props.points2}</p>
        </div>
        <div
          className={props.players.length > 2 ? "win-sub-card-multi" : "off"}
        >
          <h3>Player 3</h3>
          <p>{props.points3}</p>
        </div>
        <div
          className={props.players.length > 3 ? "win-sub-card-multi" : "off"}
        >
          <h3>Player 4</h3>
          <p>{props.points4}</p>
        </div>
        <button
          className="win-card-button-multi win-card-button-1"
          onClick={props.restart}
        >
          Restart
        </button>
        <button className="win-card-button-multi" onClick={props.newGame}>
          New Game
        </button>
      </div>
    </div>
  );
}

export default Win;
